<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kmww30/tc-custom/9781504041560.jpg?1734109833206" alt="This image is the cover for the book Live Coal in the Sea"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Live Coal in the Sea
      </h1>
      <p class="bookDescription body article font2">
        <b>A family’s deepest secrets are exposed in this “haunting domestic drama” from the award-winning author of <i>A Wrinkle in Time </i>(<i>Publishers Weekly</i>).</b><br/>  <br/> When her teenage granddaughter comes to her with a troubling question, Camilla Dickinson must confront the painful history she’s long kept hidden. Forced to relive her past, she relates a complex saga involving her beautiful, adulterous mother, her troubled son, and the difficult choices that have affected three generations of her family.<br/>  <br/> As she goes through the difficult process of revealing her secrets, Camilla also lets go of the burden of lies she’s told. A testament to the power of acceptance and forgiveness, <i>A Live Coal in the Sea</i> is ultimately an exploration of the lengths to which people will go for love—and the things they’ll do to protect family.<br/>  <br/><i>This ebook features an illustrated biography of Madeleine L’Engle including rare images from the author’s estate.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Madeleine L'Engle
      </h2>
      
      <p class="authorDescription body article">Madeleine L&rsquo;Engle (1918&ndash;2007) was an American author of more than sixty books, including novels for children and adults, poetry, and religious meditations. Her best-known work, <I>A Wrinkle in Time</I>, one of the most beloved young adult books of the twentieth century and a Newbery Medal winner, has sold more than fourteen million copies since its publication in 1962. Her other novels include <I>A Wind in the Door</I>,<I> A Swiftly Tilting Planet</I>, and <I>A Ring of Endless Light</I>. Born in New York City, L&rsquo;Engle graduated from Smith College and worked in theater, where she met her husband, actor Hugh Franklin. L&rsquo;Engle documented her marriage and family life in the four-book autobiographical series, the Crosswicks Journals. She also served as librarian and writer-in-residence at the Cathedral Church of Saint John the Divine in Manhattan for more than thirty years.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5dab8a7c